<template>
	<div class="view">
		<PetSearch
			class="pet-search"
			@selected="onSelected"
			:addButton="$isGod()"
		/>
	</div>
</template>

<script>
import PetSearch from '@/components/PetSearch'

export default {
	name: 'PetsPage',
	components: {
		PetSearch,
	},
	methods: {
		onSelected(res) {
			this.$router.push('/chats/' + res.chat)
		},
	},
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.view {
	width: 100%;
}

.pet-search {
	margin-top: 50px;
}
</style>
